import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const auvik = defineConnector({
  identifier: "auvik",
  name: "Auvik",
  tagLine: "Network management and monitoring",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://auvikapi\\.[^/]*\\.my\\.auvik\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Find your Auvik API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Auvik API overview](https://api.auvik.com) and create API credentials from your Auvik account settings. Copy the username, API key, and the region for the Auvik pod your account uses.",
        },
      ],
    },
    {
      title: "Connect your Auvik account",
      items: [
        {
          kind: "markdown",
          content: "Enter your Auvik instance details and API credentials.",
        },
        {
          kind: "input",
          label: "Region",
          placeholder: "us2",
          required: true,
          target: { kind: "configuration", field: "region" },
          helperText:
            "The region of your Auvik account (visible in your browser address bar when logging into the Auvik web UI)",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "secrets", field: "username" },
          helperText:
            "Auvik User Name (usually an individual user's email address)",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "password" },
          placeholder: "aJ7EjSEDD+7+JqlQ1NtUXyY/3/05GGWwfF7vBbPd0Iy8HG1s",
          helperText: "Auvik API Key (separate from the user's password)",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://auvikapi.${configuration.region}.my.auvik.com/v1/authentication/verify`,
  },
  publicEnvVars: ({ region }) => ({
    AUVIK_REGION: region || "",
  }),
});
